<template>
  <a-sub-menu :key="menuInfo.id" @click.stop="() => gaApi(menuInfo)">
    <template v-slot:title>
      <span>
        <img
          :src="menuInfo.menuIcon"
          alt=""
          v-if="menuInfo.menuIcon"
          class="menuIcon"
        />
        <!-- <span>{{ menuInfo.menuName }}</span> -->
        <a-tooltip
          placement="top"
          overlayClassName="Ktool"
          :color="overColor"
          :title="
            isEnglish && menuInfo.menuNameEn
              ? menuInfo.menuNameEn
              : menuInfo.menuName
          "
        >
          <span :key="isEnglish">{{
            isEnglish && menuInfo.menuNameEn
              ? menuInfo.menuNameEn
              : menuInfo.menuName
          }}</span>
        </a-tooltip>
      </span>
    </template>
    <template v-for="item in menuInfo.childrenList" :key="item.id">
      <sidebar-item
        :menu-info="item"
        v-if="item.menuType != 2 && item.childrenList"
        :key="item.id"
        @click.stop="() => gaApi(item)"
      />
      <a-menu-item
        :key="item.menuPath"
        :id="item.id"
        v-else
        @click.stop="() => gaApi(item)"
      >
        <!-- 图标 -->
        <img
          :src="item.menuIcon"
          alt=""
          v-if="item.menuIcon"
          class="menuIcon"
        />
        <a-tooltip
          overlayClassName="Ktool"
          placement="right"
          :color="overColor"
          :title="
            isEnglish && item.menuNameEn ? item.menuNameEn : item.menuName
          "
        >
          <span>{{
            isEnglish && item.menuNameEn ? item.menuNameEn : item.menuName
          }}</span>
        </a-tooltip>
      </a-menu-item>
    </template>
  </a-sub-menu>
</template>

<script>
import { ref, getCurrentInstance, reactive, toRefs } from 'vue'
// import { cupshe_GA } from 'cupshe-ga'
import { useStore } from 'vuex'
export default {
  name: 'SildebarItem',
  props: {
    menuInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const {
      proxy: { i18n }
    } = getCurrentInstance()
    const isEnglish = ref(i18n.global.locale !== 'zh-CN')
    const store = useStore()
    const state = reactive({
      // 监听菜单 触发埋点
      gaApi: item => {
        const { id, menuName } = item
        const { userName, userId } = store.state.user.userInfo
        // cupshe_GA(
        //   'click',
        //   {
        //     shop_id: '101',
        //     log_type: '2',
        //     event_category: 'click',
        //     event_name: 'btn_click',
        //     referer: window.history.state.back
        //   },
        //   {
        //     btn_id: 'PRO-' + id,
        //     btn_name: menuName + '',
        //     menu_name: menuName + '',
        //     menu_id: id + '',
        //     system_code: 'PRO',
        //     system_name: 'Portal统一登录系统',
        //     uname: userName,
        //     uid: userId,
        //     time: new Date()
        //   }
        // )
      }
    })

    return {
      isEnglish: isEnglish.value,
      overColor: '#a7a7a7',
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.menuIcon {
  width: 15px;
  height: 15px;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
  margin-top: -5px;
}
</style>
<style>
/* .ant-menu > .ant-menu-item,
.ant-menu > .ant-menu-submenu > .ant-menu-submenu-title {
  padding-left: 16px !important;
}
.ant-menu-sub .ant-menu-item {
  padding-left: 32px !important;
} */

.ant-layout-sider-collapsed .ant-menu-submenu-title,
.ant-layout-sider-collapsed .ant-menu-submenu > .ant-menu-submenu-title,
.ant-layout-sider-collapsed .ant-menu-item {
  padding-left: 8px !important;
  padding-right: 8px !important;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  overflow: hidden;
}
</style>
